import { createContext } from 'react';
import type { UtilisateurConnecte } from '../lib/types';

export interface ContexteAuth {
  utilisateur: UtilisateurConnecte | null;
  /** Vrai pendant la vérification initiale de la session. */
  chargement: boolean;
  connexion: (email: string, motDePasse: string) => Promise<void>;
  /**
   * Installe une session déjà ouverte par l'API. Sert à l'activation de
   * l'espace candidat : le cookie est posé par la réponse, il n'y a pas de
   * seconde authentification à faire.
   */
  installerSession: (utilisateur: UtilisateurConnecte) => void;
  deconnexion: () => Promise<void>;
  /** L'écran fait-il partie du périmètre renvoyé par l'API ? */
  peutAcceder: (ecran: string) => boolean;
}

export const ContexteAuthentification = createContext<ContexteAuth | null>(null);
